define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        LinkAction   = require("shared/ui/experience/action/link/LinkAction"),
        template     = require("ui/experience/action/link/LinkActionPropertiesView.tpl");

    /**
     * Properties view for the link action.
     *
     * @class LinkActionPropertiesView
     * @constructor
     *
     * @cfg {LinkAction} model The action to display in the view.
     */
    return ImprovedView.extend({
        template: template,

        regions: {
            linkProperties: ".link-action-properties"
        },

        bindings: {
            ".url": "url",
            ".alt-text": {
                observe: "emailAltText",
                onGet: function(value) {
                    return value ? String(value).trim() : null;
                },
                onSet: function(value) {
                    return value ? String(value).trim() : null;
                }
            },
            ".target": {
                observe: "target",
                selectOptions: {
                    collection: [
                        {label: "Current window/tab", value: LinkAction.CURRENT_WINDOW},
                        {label: "New window/tab",     value: LinkAction.NEW_WINDOW}
                    ]
                }
            }
        },
        experienceModelBindings: {
            ".alt-text-region": {
                observe: "emailModeEnabled",
                updateModel: false,
                update: function($el, isEmailMode) {
                    $el.toggle(isEmailMode);
                }
            }
        },

        onRender: function() {
            this.stickit(this.viewScope.viewModel.get("experience"), this.experienceModelBindings);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/link/LinkActionPropertiesView.js